"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const StoresUtil_1 = require("../../util/StoresUtil");
const AnonymousContent_1 = require("./informationmodalcontents/AnonymousContent");
const BasicInfoContent_1 = require("./informationmodalcontents/BasicInfoContent");
const CollectDataContent_1 = require("./informationmodalcontents/CollectDataContent");
const CommunicationContent_1 = require("./informationmodalcontents/CommunicationContent");
const CommunicationWithTeliaContent_1 = require("./informationmodalcontents/CommunicationWithTeliaContent");
const CreditRatingContent_1 = require("./informationmodalcontents/CreditRatingContent");
const DataProccessingContent_1 = __importDefault(require("./informationmodalcontents/DataProccessingContent"));
const DataProccessingContractContent_1 = __importDefault(require("./informationmodalcontents/DataProccessingContractContent"));
const DataProccessingLegalContent_1 = __importDefault(require("./informationmodalcontents/DataProccessingLegalContent"));
const DataProcessingWithConsentContent_1 = require("./informationmodalcontents/DataProcessingWithConsentContent");
const DebtManagementContent_1 = require("./informationmodalcontents/DebtManagementContent");
const KidsContent_1 = require("./informationmodalcontents/KidsContent");
const LocationContent_1 = require("./informationmodalcontents/LocationContent");
const MarketingProfilingContent_1 = require("./informationmodalcontents/MarketingProfilingContent");
const MessageContent_1 = require("./informationmodalcontents/MessageContent");
const NonPersonalContent_1 = require("./informationmodalcontents/NonPersonalContent");
const PersonalDataContent_1 = require("./informationmodalcontents/PersonalDataContent");
const PersonalDataPrincipleContent_1 = require("./informationmodalcontents/PersonalDataPrincipleContent");
const ProtectPersonalDataContent_1 = require("./informationmodalcontents/ProtectPersonalDataContent");
const PublicPrivacyNoticeModalContentUtil_1 = require("./informationmodalcontents/PublicPrivacyNoticeModalContentUtil");
const RightsPersonalDataContent_1 = __importDefault(require("./informationmodalcontents/RightsPersonalDataContent"));
const ThirdPartyDataContent_1 = require("./informationmodalcontents/ThirdPartyDataContent");
const PublicPrivacyNoticeContactModal_1 = __importDefault(require("./PublicPrivacyNoticeContactModal"));
let PublicPrivacyNoticeInfoModal = class PublicPrivacyNoticeInfoModal extends react_1.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getModalContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { type } = this.props;
                switch (type) {
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.BASIC_INFO:
                        return react_1.default.createElement(BasicInfoContent_1.BasicInfoContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.COMMUNICATION:
                        return react_1.default.createElement(CommunicationContent_1.CommunicationContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.LOCATION:
                        return react_1.default.createElement(LocationContent_1.LocationContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.MESSAGE:
                        return react_1.default.createElement(MessageContent_1.MessageContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.COMMUNICATION_WITH_TELIA:
                        return react_1.default.createElement(CommunicationWithTeliaContent_1.CommunicationWithTeliaContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.PERSONAL_DATA:
                        return react_1.default.createElement(PersonalDataContent_1.PersonalDataContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.KIDS:
                        return react_1.default.createElement(KidsContent_1.KidsContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.NON_PERSONAL:
                        return react_1.default.createElement(NonPersonalContent_1.NonPersonalContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.ANONYMOUS:
                        return react_1.default.createElement(AnonymousContent_1.AnonymousContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.COLLECT_DATA:
                        return react_1.default.createElement(CollectDataContent_1.CollectDataContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DATA_PROCESSING:
                        return react_1.default.createElement(DataProccessingContent_1.default, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DATA_PROCESSING_WITH_CONSENT:
                        return react_1.default.createElement(DataProcessingWithConsentContent_1.DataProcessingWithConsentContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DATA_PROCESSING_CONTRACT:
                        return react_1.default.createElement(DataProccessingContractContent_1.default, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DATA_PROCESSING_LEGAL:
                        return react_1.default.createElement(DataProccessingLegalContent_1.default, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.MARKETING_PROFILING:
                        return react_1.default.createElement(MarketingProfilingContent_1.MarketingProfilingContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.CREDIT_RATING:
                        return react_1.default.createElement(CreditRatingContent_1.CreditRatingContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DEBT_MANAGEMENT:
                        return react_1.default.createElement(DebtManagementContent_1.DebtManagementContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.PERSONAL_DATA_PRINCIPLE:
                        return react_1.default.createElement(PersonalDataPrincipleContent_1.PersonalDataPrincipleContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.THIRD_PARTY_DATA:
                        return react_1.default.createElement(ThirdPartyDataContent_1.ThirdPartyDataContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.PROTECT_PERSONAL_DATA:
                        return react_1.default.createElement(ProtectPersonalDataContent_1.ProtectPersonalDataContent, null);
                    case PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.RIGHTS_PERSONAL_DATA:
                        return react_1.default.createElement(RightsPersonalDataContent_1.default, null);
                    default:
                        return react_1.default.createElement(BasicInfoContent_1.BasicInfoContent, null);
                }
            }
        });
    }
    render() {
        const { heading } = this.props;
        const { showContactModal } = this.publicPrivacyNoticeStore;
        return showContactModal ? (react_1.default.createElement(PublicPrivacyNoticeContactModal_1.default, null)) : (react_1.default.createElement(lib_1.Modal, { size: "8-col", hasContentComponent: true, isHeaderSticky: true, "aria-labelledby": "modal-heading" },
            react_1.default.createElement(lib_1.ModalHeader, null,
                react_1.default.createElement(lib_1.Heading, { className: "h2", id: "modal-heading" }, heading)),
            react_1.default.createElement(lib_1.ModalContent, null, this.getModalContent())));
    }
};
PublicPrivacyNoticeInfoModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], PublicPrivacyNoticeInfoModal);
exports.default = PublicPrivacyNoticeInfoModal;
